__turbopack_context__.v({
  "pdfSection": "PdfSection-module-scss-module__3yjoOq__pdfSection",
  "title": "PdfSection-module-scss-module__3yjoOq__title",
  "viewer": "PdfSection-module-scss-module__3yjoOq__viewer",
  "viewerWrapper": "PdfSection-module-scss-module__3yjoOq__viewerWrapper",
});
